<template>
  <div>
    <span v-if="target==='qtyincrease'">
      <el-button
        circle
        type="primary"
        size="mini"
        icon="el-icon-circle-plus-outline"
        :disabled="$store.state.qtyincreaseid.includes(props.rowData._id)"
        @click="qtyincrease(props.rowData,props.rowField)"
      ></el-button>
    </span>
    <span v-if="target==='qtyreduce'">
      <el-button
        circle
        type="primary"
        size="mini"
        icon="el-icon-remove-outline"
        :disabled="$store.state.qtyreduceid.includes(props.rowData._id)"
        @click="qtyreduce(props.rowData,props.rowField)"
      ></el-button>
    </span>

    <!-- 数量选择框 -->
    <el-drawer :with-header="false" direction="btt" size="80%" :wrapperClosable="false"
    :visible.sync="qtydialog" title="选择数量">
      <qtyedit
        :props="props"
        :actionobj="actionobj"
        :target="qtyedittarget"
        :index="qtyeditindex"
        @edited="qtydialog=false"
      ></qtyedit>
    </el-drawer>
  </div>
</template>
<script>
import qtyedit from "./qtyedit";

export default {
  // props: ["actionobj","target", "index"],
  components:{qtyedit},
  props: ["props", "target"],
  data() {
    return {
      actionobj: {},
      qtyedittarget: "",
      qtyeditindex: 0,
      qtydialog: false
    };
  },
  methods: {

    qtyedit(target) {
      this.qtydialog = true;
      this.qtyedittarget = target;
      this.qtyeditindex = this.$store.state[target].length - 1;
    },

    qtyincrease(data, field) {
      // console.log(this.fields)
      data[field.changer || "number"] = 1; //如果未定义changer，那么默认为number
      // data.number = 1;
      data.remark = "";
      this.$store.commit("setqtyincrease", data);
      this.actionobj = field;
      this.qtyedit("qtyincrease");
      //this.$message(data.item + "已添加到材料申请");
    },
    qtyreduce(data, field) {
      // console.log(data)
      // let actioninobj=this.fields.find(ele=>{return ele.name==="actionout"})
      data[field.changer || "number"] = 1; //如果未定义changer，那么默认为number
      //data.number = 1;
      data.remark = "";
      this.$store.commit("setqtyreduce", data);
      this.actionobj = field;
      this.qtyedit("qtyreduce");
      //this.$message(data.item + "已添加到出库申请");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/utility/commonfields/actionoutin/index.vue